export default __webpack_public_path__ + "acb57ae272189dbc4e2f237ecabb4e38.svg";